function classNames(...classes: string[]): string {
    return classes.filter(Boolean).join(' ');
}

const Class = {
    classNames,
};

export default Class;
